/* eslint-disable import/prefer-default-export */

export const decodeId = (id, type) => parseInt(decodeURIComponent(id).split(`gid://shopify/${type}/`)[1], 10);

/*
For ADA compliance - only including one anchor tag per content block/card + using JS for remaining elements that need to link mouse users
ex. where whole cards should be clickable
*/
document.querySelectorAll('[data-featured-link]').forEach((nonAnchorLink) => {
  nonAnchorLink.addEventListener('click', () => {
    const link = nonAnchorLink.getAttribute('data-featured-link');
    window.location.href = link;
  });
});

export const isFirstPage = () => {
  const url = new URL(window.location.href);
  const urlParams = new URLSearchParams(url.search);
  const pageParam = urlParams.get('page');
  return !pageParam || pageParam === '1';
};

export const validateEmail = (email) =>
  // eslint-disable-next-line no-useless-escape, max-len
  /^[a-zA-Z0-9!#$%&\'*+\\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&\'*+\\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/.test(
    email,
  );

export const validatePhoneNumber = (v) =>
  v.length === 10 &&
  // eslint-disable-next-line no-useless-escape
  /^[-\s\./0-9]*$/g.test(v);

export const unwrapRTEContent = (html) => {
  const tempContainer = document.createElement('div');
  tempContainer.innerHTML = html;
  return tempContainer.firstChild.innerHTML;
};

export const slugify = (text) =>
  text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^\w-]+/g, '');
